import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  /* RESET | meyerweb.com/eric/tools/css/reset | v2.0 | 20110126 */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    box-sizing: border-box;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  input, textarea {
    -webkit-appearance: none;
    -moz-appearance: none;
  }
  /* END OF RESET */

  * {
    -moz-appearance: none;
    -webkit-appearance: none;
  }

  html, body {
    background: ${props => props.theme.colors.background.surface};
    font-family: ${props => props.theme.fonts.primary.family};
    font-weight: ${props => props.theme.fonts.weights.regular};
    color: ${props => props.theme.colors.text.dark};
    height: 100%;

    #root {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  }

  body {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    &.no-scroll {
      overflow: hidden;
    }
  }

  a {
    color: ${props => props.theme.colors.text.dark};
  }

  ::selection {
    background: ${props => props.theme.colors.background.hightlight};
  }
`;
